import {
    useContext,
    useEffect,
    useState
} from 'react';
import Head from 'next/head';

import { RequestNextApi } from '../../../api/Request';
import { ProgressContext } from '../../../components/Context/progressContext';
import MarketingNavigation from '../../../navigation/marketing';
import { showArticleBlock } from '../../../utils/static-pages/function';
import { PAGES_SLUG } from '../../../utils/static-pages/model';
import { ShowNotification } from '../../../utils/notification/snackbarUtils';

export default function Ministries() {
    const [articleBlocks, setArticleBlocks] = useState();
    const { state: progressContext, update: updateProgress } = useContext(ProgressContext);
    useEffect(() => {
        const fetchPage = async () => {
            try {
                const res = await RequestNextApi.post('/pages',
                    {
                        slug: PAGES_SLUG.MINISTRIES
                    }
                );
                if (res.data.success) {
                    setArticleBlocks(res.data.page.articleBlocks);
                } else {
                    ShowNotification.error('Fetch page failed');
                }
            } catch (error) {
                ShowNotification.error('Fetch page failed');
            }
        };

        const initPage = async () => {
            updateProgress({ isLoading: true });
            await fetchPage();
            updateProgress({ isLoading: false });
        }

        initPage();
    }, []);


    return (
        <>
            <Head>
                <title>Activate Client Generosity | Kingdom Advisors</title>
                <meta name="description" content="Kingdom Advisors introduces its members to carefully vetted, difference-making ministries to bring clients the generosity opportunities they are looking for." />
            </Head>
            <MarketingNavigation>
                <div className='large-firms'>
                    {articleBlocks && articleBlocks.map((item, index) => (
                        showArticleBlock(item, index)
                    ))}
                </div>
            </MarketingNavigation>
        </>
    )
}

Ministries.getLayout = page => <>{page}</>;
Ministries.isPublic = true;
